const DAY = new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', timeZone: 'UTC' })

/**
 * `YYYY-MM-DD` → "Nov 15", read as the calendar day it names. A bare-string
 * `Date` is UTC midnight and, formatted in a western timezone, is the day
 * before — so the date is built with `Date.UTC` and formatted in UTC.
 */
export function dayLabel(iso: string): string {
  const [y, m, d] = iso.split('-').map(Number)
  if (y === undefined || m === undefined || d === undefined) return iso
  return DAY.format(new Date(Date.UTC(y, m - 1, d)))
}

/** "Oct 16 – Nov 15" (en dash). */
export function rangeLabel(startDate: string, endDate: string): string {
  return `${dayLabel(startDate)} – ${dayLabel(endDate)}`
}

export function transactionCountLabel(n: number): string {
  if (n === 0) return 'No posted transactions yet'
  return n === 1 ? '1 transaction' : `${n} transactions`
}

export function otherCurrencyNote(n: number): string | null {
  if (n <= 0) return null
  return n === 1
    ? "1 transaction in another currency isn't included."
    : `${n} transactions in another currency aren't included.`
}
